import { api, formatParams, config } from "@/utils/axios";

// 角色分页查询
export function queryPage(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/role/findAllRole`,
    })
  );
}

// 获取所有权限
export function getAllPermisson(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/role/getAllPermisson`,
    })
  );
}

// 新增角色
export function insert(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/role/saveRole`,
    })
  );
}

// 修改角色
export function update(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/role/update/${params.id}`,
    })
  );
}

// 删除角色
export function del(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/role/del/${params.id}`,
    })
  );
}

// 获取角色详情
export function getRoleDetails(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/role/findRoleById/${params.id}`,
    })
  );
}

// 获取角色所有用户
export function findRoleAndUser(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/role/findRoleAndUser?id=${params.id}`,
    })
  );
}
